<!-- 由 suu 创建于 2021-01-21 星期四 -->
<template>
  <div
    class="training-pro-overview"
    :class="{ 'training-pro-overview-vip': ufrom == 'vip' }"
    ref="box"
    v-if="dinfo"
  >
    <div class="o-top">
      <img
        class="t-img"
        v-if="dinfo.member_image && showImg"
        @error="handelImgError"
        :src="dinfo.member_image"
        alt
      />
      <div class="t-left">
        <div class="l-name">{{ dinfo.member_name }}</div>
        <div class="uir_uiu_badge" v-if="dinfo.medal_num">
          <img src="@/assets/imgs/scancode/sum-medal.png" />
          <span class="badge-num">{{ ` ${dinfo.medal_num || '0'}` }}</span>
          <span>徽章</span>
        </div>
      </div>
      <div class="t-right">
        <div class="r-coach">评估教练：{{ dinfo.coach_name }}</div>
        <div class="r-date">{{ dinfo.day }}</div>
      </div>
    </div>
    <div class="o-section">
      <!-- 教练总结 -->
      <div class="coach-summary">
        <div class="s-title">教练总结</div>
        <div class="s-cent">{{ dinfo.coach_summary }}</div>
      </div>
      <!-- 数据结论 -->
      <div class="data-cent">
        <!-- 总评分 -->
        <div class="total-data">
          <div class="td-text">您的综合评估超越了</div>
          <div class="td-num">{{ dinfo.fight }}%</div>
          <div class="td-text">的健萌er</div>
          <!-- 能力蛛网图 -->
          <AbilityRadar
            :info="dinfo.data_map"
            class="ability-data"
          ></AbilityRadar>
        </div>
        <template v-if="showMore && showShareBtn">
          <div class="dc-line"></div>
          <!-- 身体数据 -->
          <div class="data-item">
            <div class="item-title">
              <div class="t-left">基础数据</div>
              <div
                class="t-right"
                :class="{
                  't-right-red': dinfo.body_score.score < 60,
                  't-right-yellow': dinfo.body_score.score < 80
                }"
              >
                {{ dinfo.body_score.score }}分
              </div>
            </div>
            <div class="item-sub">
              打败了
              <span>{{ dinfo.body_score.fight }}%</span>
              的健萌er，{{
                dinfo.body_score.fight < 80
                  ? '继续加油哦！'
                  : '实在是太优秀了！'
              }}
            </div>
            <div class="data-change-title">
              <span class="t-left">项目</span>
              <span>当前值</span>
              <span>与上一次比</span>
            </div>
            <div
              class="data-card"
              v-for="(item, index) in dinfo.body_score.list"
              :key="index"
            >
              <div class="card-desc">
                <div class="d-text d-title">{{ item.title }}</div>
                <div class="d-text">{{ item.cur }}{{ item.unit }}</div>
                <div
                  class="d-change"
                  :class="{ 'd-change-up': item.change >= 0 }"
                >
                  <template v-if="item.change">
                    <span class="change-icon"></span>
                    {{ item.change > 0 ? '+' + item.change : item.change
                    }}{{ item.unit }}
                  </template>
                </div>
                <!-- <div class="d-btn user-btn">历史</div> -->
              </div>
              <BodyDataRange
                class="card-range"
                v-if="item.rangeInfo"
                barWidth="80"
                :rangeInfo="item.rangeInfo"
              ></BodyDataRange>
              <div
                class="dashed-line"
                v-if="index != dinfo.body_score.list.length - 1"
              ></div>
            </div>
          </div>
          <div class="dc-line" v-if="dinfo.posture_score.score"></div>
          <!-- 体态评估 -->
          <div class="data-item" v-if="dinfo.posture_score.score">
            <div class="item-title">
              <div class="t-left">体态评估</div>
              <div
                class="t-right"
                :class="{
                  't-right-red': dinfo.posture_score.score < 60,
                  't-right-yellow': dinfo.posture_score.score < 80
                }"
              >
                {{ dinfo.posture_score.score }}分
              </div>
            </div>
            <div class="item-sub">
              打败了
              <span>{{ dinfo.posture_score.fight }}%</span>
              的健萌er，{{
                dinfo.posture_score.fight < 80
                  ? '继续加油哦！'
                  : '实在是太优秀了！'
              }}
            </div>
            <div class="pos-list" v-if="dinfo.posture_score.bug">
              <div
                class="pos-item"
                v-for="(item, index) in dinfo.posture_score.bug.split(',')"
                :key="index"
              >
                {{ item }}
                <span
                  class="item-tag"
                  v-if="showTag(item)"
                  :style="{ backgroundColor: showTag(item).color }"
                >
                  {{ showTag(item).tag }}
                </span>
              </div>
            </div>
            <div class="pos-con-title">评估结论：</div>
            <div class="pos-con-cent">{{ dinfo.posture_score.comment }}</div>
            <!-- 体态评估图 -->
            <template v-if="ufrom != 'vip' && posImgs">
              <div class="pos-con-title">体态评估图：</div>
              <div class="pos-con-imgs">
                <img
                  class="pc-img"
                  v-if="item"
                  v-for="(item, index) in posImgs"
                  :key="index"
                  :src="item"
                  @click="previewImg(item)"
                  alt=""
                />
              </div>
            </template>
          </div>
          <div class="dc-line" v-if="dinfo.function_score.total_score"></div>
          <!-- 功能筛查 -->
          <div class="data-item" v-if="dinfo.function_score.total_score">
            <div class="item-title">
              <div class="t-left">功能筛查</div>
              <div
                class="t-right"
                :class="{
                  't-right-red': dinfo.function_score.total_score < 60,
                  't-right-yellow': dinfo.function_score.total_score < 80
                }"
              >
                {{ dinfo.function_score.total_score }}分
              </div>
            </div>
            <div class="item-sub">
              打败了
              <span>{{ dinfo.function_score.fight }}%</span>
              的健萌er，{{
                dinfo.function_score.fight < 80
                  ? '继续加油哦！'
                  : '实在是太优秀了！'
              }}
            </div>
            <div class="fun-title">
              <div>
                排除测试
                <br />左/右
              </div>
              <div>左/右</div>
              <div>结论</div>
            </div>
            <div class="dashed-line"></div>
            <div
              class="fun-item"
              v-for="(item, index) in dinfo.function_score.details"
              :key="index"
            >
              <div class="f-i-top" v-if="item.res">
                <div class="i-t-left">{{ item.second_name }}</div>
                <div class="i-t-right">
                  <div class="r-block-region">
                    <div
                      class="r-block"
                      v-if="item.exclusion_test.length"
                      :style="{
                        backgroundColor:
                          formatObj['a_' + item.res].color || item.color
                      }"
                    >
                      <span
                        class="b-test"
                        v-for="(bt, bti) in item.exclusion_test"
                        :key="bti"
                        >{{ formatObj['a_' + bt].val }}</span
                      >
                    </div>
                  </div>
                  <div class="r-block-region">
                    <div
                      class="r-block"
                      v-if="item.common_test.length"
                      :style="{
                        backgroundColor:
                          formatObj['a_' + item.res].color || item.color
                      }"
                    >
                      <span
                        class="b-test"
                        v-for="(bt, bti) in item.common_test"
                        :key="bti"
                        >{{ formatObj['a_' + bt].val }}</span
                      >
                    </div>
                  </div>
                  <div class="r-block-region">
                    <div
                      class="r-block"
                      v-if="item.res"
                      :style="{
                        backgroundColor:
                          formatObj['a_' + item.res].color || item.color
                      }"
                    >
                      {{ formatObj['a_' + item.res].val }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="f-i-not">{{ item.notice }}</div>
              <div
                class="dashed-line"
                v-if="index != dinfo.function_score.details.length - 1"
              ></div>
            </div>
          </div>
          <div class="dc-line"></div>
          <!-- 运动能力 -->
          <div
            class="data-item"
            v-if="dinfo.athletic_score && dinfo.athletic_score.total_score"
          >
            <div class="item-title">
              <div class="t-left">运动能力</div>
              <div
                class="t-right"
                :class="{
                  't-right-red': dinfo.athletic_score.total_score < 60,
                  't-right-yellow': dinfo.athletic_score.total_score < 80
                }"
              >
                {{ dinfo.athletic_score.total_score }}分
              </div>
            </div>
            <div class="item-sub">
              打败了
              <span>{{ dinfo.athletic_score.fight }}%</span>
              的健萌er，{{
                dinfo.athletic_score.fight < 80
                  ? '继续加油哦！'
                  : '实在是太优秀了！'
              }}
            </div>
            <div
              class="ath-item"
              v-for="(item, index) in dinfo.athletic_score.scores"
              :key="index"
            >
              <div class="at-cent">
                <div class="ac-left">{{ item.name }}</div>
                <van-rate
                  :value="item.star || 0"
                  :size="14"
                  readonly
                  color="#ffd554"
                  void-icon="star"
                  void-color="#dddddd"
                />
              </div>
              <div
                class="dashed-line"
                v-if="index != dinfo.athletic_score.scores.length - 1"
              ></div>
            </div>
          </div>
        </template>
        <div
          class="more-btn user-btn u-text-center"
          v-if="showShareBtn"
          @click="showMore = !showMore"
        >
          <van-icon name="arrow-up" v-if="showMore" />
          <van-icon name="arrow-down" v-else />
          <span>{{ showMore ? '收起' : '展开' }}</span>
        </div>
      </div>
    </div>
    <div class="tp_m_btns" v-if="showShareBtn">
      <div class="tp_mb_pre user-btn" @click="onLast">
        {{ ufrom == 'vip' ? '返回' : '上一步' }}
      </div>
    </div>
    <!-- <myMask
      v-if="showMask"
      @click.native=";(showMask = false), (showShareBtn = true)"
    ></myMask> -->
    <div
      @click=";(showMask = false), (showShareBtn = true)"
      :class="['share-img', showMask ? 'on-share-img' : '']"
      v-if
    >
      <img :src="imgUrl" alt />
    </div>
    <div class="footer" v-show="!showShareBtn">
      <canvas class="qr" id="qrCode-canvas"></canvas>
      <div class="f-right">
        <div class="f-text">
          长按识别二维码
          <br />享受专业一对一私教课
        </div>
        <img src="https://cdnvue.gymcity.com.cn/uploads/pub-caise-logo" alt />
      </div>
    </div>
  </div>
</template>

<script>
// import '@/styles/Din/Din.css'
import AbilityRadar from './ponents/ability-radar.vue'
import BodyDataRange from './ponents/body-data-range.vue'
import QRCode from 'qrcode'
import html2canvas from 'html2canvas'
// import myMask from '@/components/CustomComponent/myMask'

export default {
  name: 'training-pro-overview',

  components: { BodyDataRange, AbilityRadar },

  props: {},

  data() {
    return {
      formatObj: {
        a_0: { val: '医学干预', color: '#7d43aa' },
        a_1: { val: '不合格', color: '#dc0050' },
        a_2: { val: '合格', color: '#f7b500' },
        a_3: { val: '优', color: '#35c763' },
        'a_+': { val: '+', color: '#dc0050' },
        'a_-': { val: '-', color: '#35c763' },
        'a_＋': { val: '+', color: '#dc0050' }
      },
      ufrom: this.$route.query.ufrom || '', // 当前用户来源 身份 vip 为会员用户
      showImg: true,
      lock: false,
      showMore: false,
      imgUrl: null,
      showMask: false,
      showShareBtn: true,
      tpid: this.$route.query.tpid,
      level: this.$route.query.level,
      uid: this.$route.query.uid,
      post: '扁平足,足外旋,腿部垂线与足底不垂直',
      dinfo: null,
      oInfo: {
        body_score: [
          {
            title: '体重',
            cur: '52',
            unit: 'kg',
            change: -2,
            rangeInfo: {
              norm_range: ['偏瘦', '健康', '偏胖', '肥胖'],
              range: [18.5, 24, 28],
              cur: 16.2,
              unit: ''
            }
          }
        ]
      },
      posImgs: null // 体态评估图
    }
  },

  computed: {
    // 分享二维码链接
    qrcodeUrl() {
      return (
        location.href.split('#')[0] +
        `?path=acceptrecommend&fid=${
          this.uid
        }&scope=snsapi_userinfo&uno=${this.$http.getLogId(
          this.uid
        )}&log_time=trainingPro&sfrom=trainingPro`
      )
    }
  },

  watch: {},

  created() {
    this.initInfo()
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 头像加载出错
    handelImgError() {
      this.showImg = false
    },
    /**
     * 显示对于标签
     */
    showTag(op) {
      if (this.dinfo.posture_score.tags) {
        for (const key in this.dinfo.posture_score.tags) {
          if (Object.hasOwnProperty.call(this.dinfo.posture_score.tags, key)) {
            const ele = this.dinfo.posture_score.tags[key]
            for (let index = 0; index < ele.length; index++) {
              const v = ele[index]
              if (v.label === op) {
                return v
              }
            }
          }
        }
      }
      return null
    },
    /**
     * 生成海报
     */
    getImg() {
      const that = this
      console.log('that.$refs.box', this.qrcodeUrl)
      this.showShareBtn = false
      window.scrollTo(0, 0)
      this.$nextTick(() => {
        // 合成分享图
        this.$Indicator.open({
          text: '正在生成图片...',
          spinnerType: 'fading-circle'
        })
        let canvas = document.getElementById('qrCode-canvas')
        QRCode.toCanvas(canvas, that.qrcodeUrl, (error) => {
          if (error) {
            console.log(error)
          } else {
            // canvas.style.margin = '0'
            // canvas.style.height = '45'
            html2canvas(that.$refs.box, {
              backgroundColor: null,
              useCORS: true
            })
              .then(function (canvas) {
                that.imgUrl = canvas.toDataURL()
                setTimeout(() => {
                  window.scrollTo(0, 0)
                  that.$Indicator.close()
                  that.showMask = true
                  that.$Toast({
                    message: '图片已生成，长按保存分享给你的好友吧',
                    position: 'middle',
                    duration: 3000
                  })
                }, 1500)
              })
              .catch((err) => {
                that.showShareBtn = true
              })
          }
        })
      })
    },

    /**
     * 上一步
     */
    onLast() {
      this.$router.back()
    },
    /**
     * 预览体态评估图
     */
    previewImg(item) {
      window['wx'].previewImage({
        current: item, // 当前显示图片的http链接
        urls: this.posImgs // 需要预览的图片http链接列表
      })
    },
    /**
     * 获取体态体态评估图
     */
    getPostureImgs() {
      this.$http
        .get(
          'coach/BodyData?a=recentPosture',
          {
            member_physical_id: this.tpid // 规划id
          },
          true
        )
        .then((res) => {
          if (res.data.code === 200 && res.data.data) {
            this.posImgs = [
              res.data.data.image1,
              res.data.data.image2,
              res.data.data.image3
            ]
          }
        })
    },
    /**
     * 获取数据
     */
    initInfo() {
      this.$toast.loading('加载中···')
      this.$http
        .get(
          'coach/TrainReport?a=summary',
          {
            member_physical_id: this.tpid, // 规划id
            uid: this.uid
          },
          true
        )
        .then((res) => {
          this.$toast.clear()
          if (res.data.code === 200) {
            this.formatObj = res.data.data.alias
            this.dinfo = res.data.data
            this.uid = res.data.data.uid
            this.getPostureImgs()
          } else {
            this.$dialog.alert({ message: res.data.msg })
          }
        })
        .catch((err) => {
          this.$dialog.alert({ message: '网络错误' })
          this.$toast.clear()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.training-pro-overview {
  width: 100vw;
  min-height: 100vh;
  background-color: #f7f7f7;
  color: #000;
  position: relative;
  text-align: left;
  padding-bottom: 25vw;
  box-sizing: border-box;
  .o-top {
    width: 100%;
    height: 36.4vw;
    box-sizing: border-box;
    padding: 3.7vw 4.5vw;
    display: flex;
    // align-items: center;
    background-color: #2882e9;
    .t-img {
      width: 12.8vw;
      height: 12.8vw;
      border-radius: 50%;
      margin-right: 2.7vw;
    }
    .t-left {
      .l-name {
        font-size: 3.7vw;
        font-weight: 600;
        color: #fff;
        margin-bottom: 1vw;
      }
      .uir_uiu_badge {
        margin-left: 2.7vw;
        // width: 14.7vw;
        height: 5.1vw;
        padding-left: 5vw;
        padding-right: 1.9vw;
        position: relative;
        background-image: linear-gradient(180deg, #ee4b4b 0%, #cc3f3f 100%);
        border-radius: 2.5vw;
        display: flex;
        align-items: center;
        & > img {
          width: 6vw;
          position: absolute;
          left: vw(-8);
        }
        & > span {
          margin-left: 0.8vw;
          font-size: 2.7vw;
          color: #ffffff;
          font-weight: 500;
        }
        span.badge-num {
          font-size: 3.2vw;
          font-weight: 600;
        }
      }
    }
    .t-right {
      flex: 1;
      text-align: right;
      font-size: 3.2vw;
      color: #ffffff;
      line-height: 5.9vw;
      font-weight: 500;
    }
  }
  .o-section {
    width: 100%;
    box-sizing: border-box;
    padding: 0 4.3vw;
    .coach-summary {
      width: 100%;
      box-sizing: border-box;
      margin-top: -16vw;
      border-radius: 1.6vw;
      padding: 4.3vw 5.3vw;
      background-color: #fff;
      .s-title {
        font-size: 4.3vw;
        font-weight: 600;
      }
      .s-cent {
        margin-top: 1.1vw;
        font-size: 3.7vw;
        line-height: 5.9vw;
      }
    }
    .data-cent {
      width: 100%;
      box-sizing: border-box;
      margin-top: 2.7vw;
      background-color: #ffffff;
      border-radius: 1.6vw;
      padding-top: 4vw;
      padding-bottom: 10vw;
      position: relative;
      .dc-line {
        width: 83.2vw;
        height: 0.3vw;
        background-color: #f1f1f1;
        margin: 5vw auto;
        margin-bottom: 0;
      }
      .total-data {
        text-align: center;
        .td-text {
          font-size: 3.7vw;
          // font-weight: 600;
          color: #000000;
        }
        .td-num {
          font-size: 10.7vw;
          font-weight: 600;
          font-family: DIN;
          // margin: 1.1vw auto;
          color: #2882e9;
        }
      }
      .data-item {
        width: 100%;
        box-sizing: border-box;
        margin-top: 5.6vw;
        .dashed-line {
          // width: 100%;
          width: 76.7vw;
          box-sizing: border-box;
          border-top: dashed 0.3vw #cccccc;
          margin: 0 auto;
          margin-top: 2.7vw;
        }
        .item-title {
          width: 100%;
          box-sizing: border-box;
          padding: 0 5.3vw;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .t-left {
            font-size: 5.3vw;
            font-weight: 600;
            color: #000000;
          }
          .t-right {
            font-size: 5.3vw;
            color: #35c763;
            font-weight: 500;
          }
          .t-right-yellow {
            color: #f7b500;
          }
          .t-right-red {
            color: #dc0050;
          }
        }
        .item-sub {
          width: 100%;
          box-sizing: border-box;
          padding: 0 5.3vw;
          font-size: 3.2vw;
          color: #000000;
          margin-bottom: 6vw;
          margin-top: 1.1vw;
          span {
            color: #2882e9;
          }
        }
        .data-change-title {
          width: 76.7vw;
          box-sizing: border-box;
          text-align: right;
          font-size: 3.2vw;
          color: #000000;
          margin: 0 auto;
          margin-top: -4vw;
          padding-bottom: 1.5vw;
          margin-bottom: 2.7vw;
          border-bottom: 0.3vw dashed #ccc;
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            min-width: 33.3%;
            text-align: right;
          }
          .t-left {
            min-width: 20%;
            text-align: left;
          }
        }
        .data-card {
          width: 100%;
          box-sizing: border-box;
          padding: 0 7.2vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          .card-desc {
            width: 100%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 3.7vw;
            color: #000;
            & > div {
              min-width: 33.3%;
              text-align: right;
            }
            .d-title {
              text-align: left;
              min-width: 20%;
            }
            .d-change {
              font-size: 3.7vw;
              font-weight: 600;
              color: #35c763;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              .change-icon {
                width: 0;
                height: 0;
                border-bottom: 0vw solid transparent;
                border-right: 1.05vw solid transparent;
                border-top: 2.1vw solid #35c763;
                border-left: 1.05vw solid transparent;
                margin-right: 1.9vw;
              }
            }
            .d-change-up {
              color: #dc0050;
              .change-icon {
                width: 0;
                height: 0;
                border-top: 0vw solid transparent;
                border-right: 1.05vw solid transparent;
                border-bottom: 2.1vw solid #dc0050;
                border-left: 1.05vw solid transparent;
                margin-right: 1.9vw;
              }
            }
            .d-btn {
              font-size: 3.2vw;
              font-weight: 600;
              color: #2882e9;
            }
          }
          .card-range {
            margin-top: 7vw;
            margin-bottom: 5vw;
          }
        }
        .data-card + .data-card {
          margin-top: 3.2vw;
        }
        // 体态评估
        .pos-list {
          width: 100%;
          box-sizing: border-box;
          padding: 0 5.3vw;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .pos-item {
            padding: 1.6vw 3.2vw;
            font-size: 3.2vw;
            color: #000;
            font-weight: 600;
            background-color: #f7f7f7;
            border-radius: 1.1vw;
            border: solid 0.3vw #f1f1f1;
            margin-bottom: 2.1vw;
            margin-right: 2.7vw;
            position: relative;
            .item-tag {
              padding: 0 1.3vw;
              font-size: 2.7vw;
              font-weight: 600;
              letter-spacing: -0.1vw;
              color: #ffffff;
              background-color: #35c763;
              border-radius: 0.5vw;
              position: absolute;
              top: -1.9vw;
              right: 0.5vw;
            }
          }
        }
        .pos-con-title {
          width: 100%;
          box-sizing: border-box;
          font-size: 3.7vw;
          font-weight: 600;
          padding: 0 5.3vw;
          margin-top: 2vw;
        }
        .pos-con-cent {
          width: 100%;
          box-sizing: border-box;
          padding: 0 5.3vw;
          font-size: 3.5vw;
          line-height: 5.9vw;
          color: rgba(0, 0, 0, 0.5);
          margin-top: 1.9vw;
        }
        // 体态图
        .pos-con-imgs {
          width: 100%;
          box-sizing: border-box;
          margin-top: 1.9vw;
          padding: 0 2vw;
          display: flex;
          justify-content: space-around;
          .pc-img {
            width: 25vw;
            height: 34vw;
            border-radius: 1vw;
            object-fit: cover;
          }
        }
        // 功能筛查
        .fun-title {
          width: 100%;
          box-sizing: border-box;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          color: rgba(0, 0, 0, 0.5);
          font-size: 2.7vw;
          padding-right: 7vw;
          div {
            width: 12vw;
            text-align: center;
          }
        }
        .fun-item {
          width: 100%;
          box-sizing: border-box;
          padding: 0 7.5vw;
          margin-top: 3.2vw;
          .f-i-top {
            width: 100%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .i-t-left {
              flex: 1;
              font-size: 3.7vw;
              color: #000000;
            }
            .i-t-right {
              font-size: 3.2vw;
              color: #ffffff;
              font-weight: bold;
              display: flex;
              align-items: center;
              .r-block-region {
                min-width: 10vw;
                height: 5.3vw;
              }
              .r-block {
                width: 100%;
                height: 5.3vw;
                padding: 0 0.5vw;
                box-sizing: border-box;
                background-color: #dc0050;
                border-radius: 1.1vw;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                font-weight: bold;
                .b-test {
                }
                .b-test + .b-test {
                  margin-left: 4.3vw;
                  position: relative;
                }
                .b-test + .b-test::before {
                  content: '';
                  width: 0.3vw;
                  height: 2.9vw;
                  background-color: #ffffff;
                  opacity: 0.3;
                  position: absolute;
                  left: -2.2vw;
                  top: 50%;
                  transform: translateY(-50%);
                }
              }
            }
            .r-block-region + .r-block-region {
              margin-left: 2.1vw;
            }
          }
          .f-i-not {
            font-size: 3.2vw;
            color: rgba(0, 0, 0, 0.5);
            margin-top: 2.7vw;
          }
        }
        .ath-item {
          width: 100%;
          box-sizing: border-box;
          padding: 0 7.5vw;
          .at-cent {
            width: 100%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .ac-left {
              font-size: 3.7vw;
            }
          }
        }
        .ath-item + .ath-item {
          margin-top: 2.1vw;
        }
      }
      .more-btn {
        width: 20.9vw;
        height: 6.4vw;
        background-color: #ffffff;
        border-radius: 3.5vw;
        border: solid 0.3vw #e7e7e7;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 50%);
        font-size: 3.2vw;
        color: rgba(0, 0, 0, 0.5);
        span {
          margin-left: 2.1vw;
        }
      }
    }
  }
  .tp_m_btns {
    width: 100%;
    box-sizing: border-box;
    height: 19vw;
    background-color: #f7f7f7;
    padding: 0 5.3vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 99;
    // position: sticky;
    // bottom: 0;
    & > div + div {
      margin-left: 3.5vw;
    }
    & > div {
      width: 100%;
      padding: 2.7vw 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 1.1vw;
      box-sizing: border-box;
      font-size: 3.7vw;
      font-family: 'cupf';
    }
    .tp_mb_pre {
      border: solid 0.3vw #e7e7e7;
      background: #fff;
      color: #000;
    }
  }
  // 海报图片
  .share-img {
    width: 0;
    // min-height: 100vh !important;
    position: absolute;
    // transform: rotate(180deg);
    top: 0;
    left: 0;
    transition: all 1.5s;
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .on-share-img {
    width: 100vw;
    transform: rotate(360deg);
    transition: all 1.5s;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #fff;
    margin-top: 8vw;
    .f-right {
      display: flex;
      flex-direction: column;
      // align-items: center;
      text-align: left;
      img {
        width: 28.9vw;
        margin-top: 3.5vw;
      }
      .f-text {
        font-size: 3.5vw;
        color: #000;
        font-weight: 450;
        text-align: left;
      }
    }
    #qrCode-canvas,
    .mini-qr-img {
      width: 20.1vw !important;
      height: 20.1vw !important;
      margin-right: 5.6vw;
      // background-color: #f00;
    }
  }
}
.training-pro-overview-vip {
  .o-top {
    background-color: #dc0050;
  }
}
</style>
